export default __webpack_public_path__ + "static/media/undraw_web_search_re_efla.91a43552.svg";